import { jsPDF } from "jspdf";

/**
 * Convert to Proper Case, preserving acronyms.
 */
function toProperCase(text: string): string {
  return text
    .split(" ")
    .map((word) =>
      /^[A-Z]+$/.test(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
}

export interface BadgeParticipant {
  title?: string;
  fname: string;
  lname?: string;
  organization?: string;
  country?: string;
  ticketType?: string;
  email?: string;
}

/**
 * Generate portrait badge with background + adaptive text layout.
 */
// export const generateBadgesPdf = async (participants: any) => {
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: [105, 148],
//   });

//   const gold = "#D39E2D";
//   const darkGreen = "#003b37";
//   const centerX = 105 / 2;

//   // Load background
//   const bg = new Image();
//   bg.src = "/images/delegate_badge.png";
//   await new Promise((res, rej) => {
//     bg.onload = res;
//     bg.onerror = rej;
//   });

//   for (let i = 0; i < participants.length; i++) {
//     const p = participants[i];
//     if (i > 0) doc.addPage();

//     doc.addImage(bg, "PNG", 0, 0, 105, 148);

//     const fullName =
//       [p.title, p.fname, p.lname].filter(Boolean).join(" ").toUpperCase() ||
//       "UNNAMED";
//     const organization = (p.organization || "").toUpperCase();
//     const country = p.country || "";

//     /* ========= NAME ========= */
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(darkGreen);

//     // Try different font sizes until name fits width and height box
//     const maxWidth = 90;
//     const maxHeight = 25; // vertical box just for the name block
//     let fontSize = 18;

//     while (fontSize > 12) {
//       doc.setFontSize(fontSize);
//       const lines = doc.splitTextToSize(fullName, maxWidth);
//       const textHeight = lines.length * fontSize * 0.42;
//       if (textHeight <= maxHeight) break;
//       fontSize -= 1.5;
//     }

//     const nameLines = doc.splitTextToSize(fullName, maxWidth);
//     const nameHeight = nameLines.length * fontSize * 0.42;
//     const nameStartY = 86 - nameHeight / 2; // center name mid-section
//     doc.text(nameLines, centerX, nameStartY, { align: "center" });

//     let currentY = nameStartY + nameHeight + 4;

//     /* ========= ORGANIZATION ========= */
//     if (organization) {
//       doc.setFont("helvetica", "normal");
//       doc.setTextColor(gold);
//       let orgFont = 15;
//       const orgMaxWidth = 90;
//       const orgMaxHeight = 18;

//       while (orgFont > 10) {
//         doc.setFontSize(orgFont);
//         const lines = doc.splitTextToSize(organization, orgMaxWidth);
//         const height = lines.length * orgFont * 0.42;
//         if (height <= orgMaxHeight) break;
//         orgFont -= 0.5;
//       }

//       const orgLines = doc.splitTextToSize(organization, orgMaxWidth);
//       const orgHeight = orgLines.length * orgFont * 0.42;
//       doc.text(orgLines, centerX, currentY + orgHeight / 2 - 6, {
//         align: "center",
//       });
//       currentY += orgHeight + 4;
//     }

//     /* ========= COUNTRY ========= */
//     if (country) {
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(15);
//       doc.setTextColor(darkGreen);
//       const wrappedCountry = doc.splitTextToSize(country, 80);
//       doc.text(wrappedCountry, centerX, currentY - 5, { align: "center" });
//     }

//     /* ========= OPTIONAL QR AREA ========= */
//     // For example if you add a QR, leave spacing margin ~20mm above bottom
//   }

//   return doc.output("blob");
// };

/**
 * Badge PDF generator using Montserrat fonts and proportional scaling.
 */
// export const generateBadgesPdf = async (participants: any[]) => {
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: [105, 148],
//   });

//   const gold = "#D39E2D";
//   const darkGreen = "#003b37";
//   const centerX = 52.5;

//   // ✅ Register Montserrat fonts
//   // ✅ Helper: load font and convert to Base64
//   const loadFontBase64 = async (path: string): Promise<string> => {
//     const res = await fetch(path);
//     const buffer = await res.arrayBuffer();
//     const bytes = new Uint8Array(buffer);
//     let binary = "";
//     for (let i = 0; i < bytes.byteLength; i++) {
//       binary += String.fromCharCode(bytes[i]);
//     }
//     return btoa(binary);
//   };

//   // ✅ Load and register Montserrat fonts
//   const [regular, semibold, bold] = await Promise.all([
//     loadFontBase64("/fonts/Montserrat-Regular.ttf"),
//     loadFontBase64("/fonts/Montserrat-SemiBold.ttf"),
//     loadFontBase64("/fonts/Montserrat-Bold.ttf"),
//   ]);

//   doc.addFileToVFS("Montserrat-Regular.ttf", regular);
//   doc.addFileToVFS("Montserrat-SemiBold.ttf", semibold);
//   doc.addFileToVFS("Montserrat-Bold.ttf", bold);

//   doc.addFont("Montserrat-Regular.ttf", "Montserrat", "normal");
//   doc.addFont("Montserrat-SemiBold.ttf", "Montserrat", "semibold");
//   doc.addFont("Montserrat-Bold.ttf", "Montserrat", "bold");

//   // ✅ Preload background
//   const bg = new Image();
//   bg.src = "/images/delegate_badge.png";
//   await new Promise((res, rej) => {
//     bg.onload = res;
//     bg.onerror = rej;
//   });

//   for (const p of participants) {
//     doc.addImage(bg, "PNG", 0, 0, 105, 148);

//     const fullName = [p.title, p.fname, p.lname]
//       .filter(Boolean)
//       .join(" ")
//       .toUpperCase();
//     const organization = (p.organization || "").toUpperCase();
//     const country = p.country || "";

//     // layout box between logo and QR
//     const topY = 62;
//     const bottomY = 122;
//     const availableH = bottomY - topY;
//     const maxWidth = 80;

//     // desired base sizes (px ≈ pt here)
//     let nameFont = 20;
//     let orgFont = 15;
//     let countryFont = 15;

//     // helper to compute total block height
//     const measure = () => {
//       const nameLines = doc.splitTextToSize(fullName, maxWidth);
//       const orgLines = organization
//         ? doc.splitTextToSize(organization, maxWidth)
//         : [];
//       const countryLines = country
//         ? doc.splitTextToSize(country, maxWidth)
//         : [];
//       return (
//         nameLines.length * nameFont * 0.45 +
//         (organization ? orgLines.length * orgFont * 0.45 + 2 : 0) +
//         (country ? countryLines.length * countryFont * 0.45 : 0)
//       );
//     };

//     // 🔧 shrink proportionally until all fits
//     while (measure() > availableH && nameFont > 8) {
//       nameFont *= 0.95;
//       orgFont *= 0.95;
//       countryFont *= 0.95;
//     }

//     // recalc with final sizes
//     const nameLines = doc.splitTextToSize(fullName, maxWidth);
//     const orgLines = organization
//       ? doc.splitTextToSize(organization, maxWidth)
//       : [];
//     const countryLines = country ? doc.splitTextToSize(country, maxWidth) : [];

//     const nameH = nameLines.length * nameFont * 0.45;
//     const orgH = organization ? orgLines.length * orgFont * 0.45 + 2 : 0;
//     const countryH = country ? countryLines.length * countryFont * 0.45 : 0;
//     const totalH = nameH + orgH + countryH;

//     let y = topY + (availableH - totalH) / 2;

//     // --- NAME ---
//     doc.setFont("Montserrat", "bold");
//     doc.setFontSize(nameFont);
//     doc.setTextColor(darkGreen);
//     doc.text(nameLines, centerX, y, { align: "center" });
//     y += nameH + 2;

//     // --- ORG ---
//     if (organization) {
//       doc.setFont("Montserrat", "semibold");
//       doc.setFontSize(orgFont);
//       doc.setTextColor(gold);
//       doc.text(orgLines, centerX, y, { align: "center" });
//       y += orgH;
//     }

//     // --- COUNTRY ---
//     if (country) {
//       doc.setFont("Montserrat", "normal");
//       doc.setFontSize(countryFont);
//       doc.setTextColor(darkGreen);
//       doc.text(countryLines, centerX, y + 2, { align: "center" });
//     }

//     if (
//       participants.length > 1 &&
//       p !== participants[participants.length - 1]
//     ) {
//       doc.addPage();
//     }
//   }

//   return doc.output("blob");
// };

export const generateBadgesPdf = async (
  participants: any[],
  showBackground: boolean = true
) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [125, 170],
    putOnlyUsedFonts: true,
    compress: true,
  });

  const gold = "#D39E2D";
  const darkGreen = "#003b37";

  // === Load fonts ===
  const loadFontBase64 = async (path: string): Promise<string> => {
    const res = await fetch(path);
    const buffer = await res.arrayBuffer();
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };

  const [regular, semibold, bold] = await Promise.all([
    loadFontBase64("/fonts/Montserrat-Regular.ttf"),
    loadFontBase64("/fonts/Montserrat-SemiBold.ttf"),
    loadFontBase64("/fonts/Montserrat-Bold.ttf"),
  ]);

  doc.addFileToVFS("Montserrat-Regular.ttf", regular);
  doc.addFileToVFS("Montserrat-SemiBold.ttf", semibold);
  doc.addFileToVFS("Montserrat-Bold.ttf", bold);

  doc.addFont("Montserrat-Regular.ttf", "Montserrat", "normal");
  doc.addFont("Montserrat-SemiBold.ttf", "Montserrat", "semibold");
  doc.addFont("Montserrat-Bold.ttf", "Montserrat", "bold");

  // === PADDING / LAYOUT ===
  const margin = 10; // uniform padding on all sides
  const innerWidth = 125 - margin * 3.75;
  const innerHeight = 160 - margin * 2;

  // HP LASERJET
  // const innerWidth = 125 - margin * 2;
  // const innerHeight = 170 - margin * 2;
  for (let index = 0; index < participants.length; index++) {
    const p = participants[index];
    if (index > 0) doc.addPage();

    // === Background ===
    if (showBackground) {
      // use this for blank
      // const badgeFile = p.badgeCategory
      //   ? `/images/${p.badgeCategory
      //       .toLowerCase()
      //       .replace(/\s+/g, "_")}_blank.png`
      //   : "";

      const badgeFile = p.badgeCategory
        ? `/images/${p.badgeCategory.toLowerCase().replace(/\s+/g, "_")}.png`
        : "";
      try {
        if (badgeFile) {
          const bg = new Image();
          bg.src = badgeFile;
          await new Promise<void>((resolve, reject) => {
            bg.onload = () => resolve();
            bg.onerror = reject;
          });
          // stretch the image a bit wider for preview balance (extra bleed on right/left)
          const stretchX = margin - 3; // start image 3mm earlier
          const stretchWidth = innerWidth + 6; // stretch total width by 6mm
          // doc.addImage(bg, "PNG", stretchX, margin, stretchWidth, innerHeight);
          // FULL BLEED BACKGROUND (no margins)
          // enable for blank
          // doc.addImage(bg, "PNG", 0, 0, 125, 170);

          doc.addImage(bg, "PNG", stretchX, margin, stretchWidth, innerHeight);
        }
      } catch {
        doc.setFillColor(255, 255, 255);
        doc.rect(margin, margin, innerWidth, innerHeight, "F");
      }
    } else {
      doc.setFillColor(255, 255, 255);
      doc.rect(margin, margin, innerWidth, innerHeight, "F");
    }

    // === TEXT CONTENT ===
    let fullName = [p.fname, p.lname]
      .filter(Boolean)
      .join(" ")
      .trim()
      .toUpperCase();
    let organization = (p.organization || "").trim().toUpperCase();
    let country = (p.country || "").trim().toUpperCase();

    if (country === "N/A" || country === "-") country = "";

    const hasName = !!fullName;
    const hasOrg = !!organization;
    const hasCountry = !!country;

    const boxWidth = innerWidth * 0.85; // keep safe margins for long text
    const boxCenterX = margin + innerWidth / 2 - 2;

    const topY = margin + 57; // starting reference for center group
    const reservedHeight = 55; // vertical space for all text lines

    // === Fonts ===
    let nameFont = 20;
    let orgFont = 15;
    let countryFont = 15;

    // enable for blank
    // let nameLines = ""; //doc.splitTextToSize(fullName, boxWidth);

    let nameLines = doc.splitTextToSize(fullName, boxWidth);
    let orgLines = hasOrg ? doc.splitTextToSize(organization, boxWidth) : [];
    let countryLines = hasCountry ? doc.splitTextToSize(country, boxWidth) : [];

    const getBlockHeight = () =>
      (hasName ? nameLines.length * nameFont * 0.5 : 0) +
      (hasOrg ? orgLines.length * orgFont * 0.5 + 3 : 0) +
      (hasCountry ? countryLines.length * countryFont * 0.5 : 0);

    while (getBlockHeight() > reservedHeight && nameFont > 10) {
      nameFont -= 0.5;
      orgFont -= 0.3;
      countryFont -= 0.3;
      nameLines = doc.splitTextToSize(fullName, boxWidth);
      orgLines = hasOrg ? doc.splitTextToSize(organization, boxWidth) : [];
      countryLines = hasCountry ? doc.splitTextToSize(country, boxWidth) : [];
    }

    const totalH = getBlockHeight();
    let y = topY + (reservedHeight - totalH) / 2; // perfectly vertical centered block

    // === NAME ===
    if (hasName) {
      doc.setFont("Montserrat", "semibold"); //bold for laserjet; semibold for smart
      doc.setFontSize(nameFont);
      doc.setTextColor(darkGreen);
      doc.text(nameLines, boxCenterX, y, { align: "center" });
      y += nameLines.length * nameFont * 0.5;
    }

    // === ORG ===
    if (hasOrg) {
      doc.setFont("Montserrat", "bold");
      doc.setFontSize(orgFont);
      doc.setTextColor(gold);
      doc.text(orgLines, boxCenterX, y, { align: "center" });
      y += orgLines.length * orgFont * 0.5 + 2;
    }

    // === COUNTRY ===
    if (hasCountry) {
      doc.setFont("Montserrat", "normal");
      doc.setFontSize(countryFont);
      doc.setTextColor(darkGreen);
      doc.text(countryLines, boxCenterX, y, { align: "center" });
    }
  }

  return doc.output("blob");
};
